import { useIsMobile } from "../context/MobileContext"

const inputStyle =(width='20vw',valid=true)=> {
        return(
            {
        backgroundColor:'#fff',
        padding:'12px',
        border:`1px solid ${valid?'#c7c7c7':'#fd3939'}`,
        outline:'none',
        borderRadius:'10px',
        color:'#000',
        height:'20px',
        width:width,
            }
        )
}

const VerifyInput:React.FC<{
    codeValid: boolean
}> = ({
    codeValid
})=>{

    function handleVerifyChange(e:any){
            const numbers =['0','1','2','3','4','5','6','7','8','9']
            const currentArray = Number(e.target.id.charAt(e.target.id.length - 1))
            if(e.target.value.length==1){
                if(numbers.includes(e.target.value)){
                    if(currentArray>0){
                        let newArray = currentArray
                        for(let b=1;b<6;b++){
                            if((document.getElementById('verify_char_'+String(currentArray-b)) as HTMLInputElement).value.length==0){
                                newArray = currentArray-b
                            } else {
                                b=6
                            }
                            if(currentArray-b==0){
                                b=6
                            }
                        }
                        if(newArray!=currentArray){
                            (document.getElementById('verify_char_'+String(newArray)) as HTMLInputElement).value = e.target.value
                            e.target.value = ''
                        }
                        document.getElementById('verify_char_'+String(newArray+1))?.focus()
                    } else {
                        document.getElementById('verify_char_'+String(currentArray+1))?.focus()
                    }
                } else {
                    e.target.value = ''
                }
            }
            if(e.target.value.length>1){
                let lineBeforeClean = e.target.value
                let newLine = ''
                for(let c=0;c<lineBeforeClean.length;c++){
                    if(numbers.includes(lineBeforeClean.charAt(c))){
                        newLine = newLine+lineBeforeClean.charAt(c)
                    }
                }
                if(newLine){
                    for(let a=currentArray;a<6;a++){
                        if(currentArray>0){
                            for(let b=1;b<6;b++){
                                if((document.getElementById('verify_char_'+String(currentArray-b)) as HTMLInputElement).value.length==0){
                                    a=currentArray-b
                                } else {
                                    b=6
                                }
                                if(currentArray-b==0){
                                    b=6
                                }
                            }
                        }
                        (document.getElementById('verify_char_'+String(a)) as HTMLInputElement).value = newLine.charAt(0)
                        newLine = newLine.substring(1)
                    }
                } else {
                    e.target.value=''
                }
            }
        }

    const isMobile = useIsMobile()

        function verifyForm(){
            let elements = []
            for(let a=0;a<6;a++){
                elements.push(<input autoComplete='off' id={'verify_char_'+a} style={{...inputStyle('15px',codeValid?undefined:false), ...{fontFamily:'Inter', fontWeight:'600', textAlign:'center'}}} onChange={(e)=>{handleVerifyChange(e)}}/>)
            }
            return(elements)
        }

        return(
            <div>
                {verifyForm().map((el, ind)=>{
                    return(
                        <div key={ind} style={{float:'left', marginRight:isMobile?'1px':'5px'}}>
                            {el}
                        </div>
                    )
                })}
                <div style={{clear:'both'}}/>
            </div>
        )
    }
export default VerifyInput